export const educations = [
  {
    id: 1,
    title: "Bachelor of Technology in Computer Science and Engineering",
    duration: "2021 - 2025",
    institution: "Bharat Institute of Technology",
  },
  {
    id: 2,
    title: "Higher Secondary Certificate",
    duration: "2019 - 2021",
    institution: "BIT Global School,Meerut",
  },
  {
    id: 3,
    title: "Secondary School Certificate",
    duration: "2018 - 2019",
    institution: "Vardhman Academy,Meerut",
  }
]